import * as React from 'react';
import * as superagent from 'superagent';

import {
  Button,
  ButtonTheme,
  DropdownField,
  mergeStyles,
  MultilineTextField,
  Popup,
  TextField,
  Tooltip,
  TooltipPosition,
} from '@cian/components';

import { calculateEnvironmentByHost } from '@cian/utils/lib/shared/calculate_environment_by_host';

import showNotification from '../../../../di/notification';

const style = require('./bsc_add_request.css');
const environment = calculateEnvironmentByHost(window.location.hostname);

interface IBSCDialogFormProps {
  onRequestSend: () => void;
}

interface IBSCDialogFormState {
  type?: string;
  name?: string;
  email?: string;
  phone?: string;
  bscTitle?: string;
  comment?: string;
  validated?: boolean;

  nameValidatorMessage?: string;
  contactValidatorMessage?: string;
  emailValidatorMessage?: string;
  phoneValidatorMessage?: string;
}

const validatorMessages: {
  [key: string]: string;
} = {
  name: 'Укажите имя и фамилию',
  phone: 'Укажите телефон',
};

export class BSCDialogForm extends React.Component<IBSCDialogFormProps, IBSCDialogFormState> {

  private defaultDropItems = [
    { value: 'Добавить здание в каталог БЦ', label: 'Добавить здание в каталог БЦ' },
    { value: 'Стать официальным представителем', label: 'Стать официальным представителем' },
  ];

  public constructor() {
    super();

    this.state = {
      type: this.defaultDropItems[0].value,
      name: '',
      bscTitle: '',
      comment: '',
      email: '',
      phone: '',
      validated: false,
    };
  }

  public render() {
    return (
      <div onKeyDown={(event) => this.onKeyPressed(event.keyCode)} onClick={() => this.onLayoutClick()}>
        <div className={style['cf_bsc_serp-add_request_dialog_layout']}>
          <Popup
            containerStyle={{
              position: 'relative',
            }}
          >
            <div
              onClick={(event) => event.stopPropagation()}
              className={style['cf_bsc_serp-add_request_dialog_container']}>
              <span
                className={style['cf_bsc_serp-add_request_dialog_exit_btn']}
                onClick={() => this.props.onRequestSend()}
              />
              <div className={style['cf_bsc_serp-add_request_dialog_content_area']}>
                <div className={style['cf_bsc_serp-add_request_dialog_header']}>
                  <h1>Отправить заявку</h1>
                </div>
                <div className={style['cf_bsc_serp-add_request_dialog_input_group']}>
                  <div className={style['cf_bsc_serp-add_request_dialog_label']}>Тип заявки</div>
                  <div className={style['cf_bsc_serp-add_request_dialog_value']}>
                    <DropdownField
                      value={this.state.type}
                      onValueChange={value => this.setState({ type: value.toString() })}
                      values={this.defaultDropItems}
                    />
                  </div>
                </div>
                <div className={style['cf_bsc_serp-add_request_dialog_input_group']}>
                  <div className={style['cf_bsc_serp-add_request_dialog_label']}>Имя и фамилия</div>
                  <div className={style['cf_bsc_serp-add_request_dialog_value']}>
                    <Tooltip
                      position={TooltipPosition.BOTTOM_LEFT}
                      tooltipContent={this.state.nameValidatorMessage}>
                      <TextField
                        required={true}
                        autoFocus={true}
                        invalid = {this.state.name.length === 0 && this.state.validated}
                        value={this.state.name}
                        onValueChange={value => this.onNameValueChanged(value)}
                      />
                    </Tooltip>
                  </div>
                </div>
                <div className={style['cf_bsc_serp-add_request_dialog_input_group']}>
                  <div className={style['cf_bsc_serp-add_request_dialog_label']}>Телефон</div>
                  <div className={style['cf_bsc_serp-add_request_dialog_value']}>
                    <Tooltip
                      position={TooltipPosition.BOTTOM_LEFT}
                      tooltipContent={this.state.phoneValidatorMessage}>
                      <TextField
                        required={true}
                        invalid = {this.state.phone.length === 0 && this.state.validated}
                        value={this.state.phone}
                        onValueChange={value => this.onPhoneValueChanged(value)}
                      />
                    </Tooltip>
                  </div>
                </div>
                <div className={style['cf_bsc_serp-add_request_dialog_input_group']}>
                  <div className={style['cf_bsc_serp-add_request_dialog_label']}>Email</div>
                  <div className={style['cf_bsc_serp-add_request_dialog_value']}>
                    <Tooltip
                      position={TooltipPosition.BOTTOM_LEFT}
                      tooltipContent={this.state.emailValidatorMessage}>
                      <TextField
                        value={this.state.email}
                        onValueChange={value => this.setState({ email: value })}
                      />
                    </Tooltip>
                  </div>
                </div>
                <div className={style['cf_bsc_serp-add_request_dialog_input_group']}>
                  <div className={style['cf_bsc_serp-add_request_dialog_label']}>Название БЦ</div>
                  <div className={style['cf_bsc_serp-add_request_dialog_value']}>
                    <TextField
                      value={this.state.bscTitle}
                      onValueChange={value => this.setState({ bscTitle: value })}
                    />
                  </div>
                </div>
                {
                  this.state.type === this.defaultDropItems[1].value &&
                  <div {...mergeStyles(
                    style['cf_bsc_serp-add_request_dialog_input_group'],
                    style['cf_bsc_serp-add_request_dialog_value--input_multiline'])}>
                    <div className={style['cf_bsc_serp-add_request_dialog_label']}>Комментарий</div>
                      <div className={style['cf_bsc_serp-add_request_dialog_value']}>
                        <MultilineTextField
                          value={this.state.comment}
                          onValueChange={value => this.setState({ comment: value })}
                        />
                    </div>
                  </div>
                }
              </div>
              <div className={style['cf_bsc_serp-add_request_dialog_accept_area']}>
                <Button
                  theme={ButtonTheme.BLUE_SOLID}
                  onClick={() => this.sendRequest()}
                >Отправить</Button>
              </div>
            </div>
          </Popup>
        </div>
      </div>
    );
  }

  private onNameValueChanged(name: string) {

    if (!this.state.validated) {
      this.setState({ name });
      return;
    }

    this.setState({
      name,
      nameValidatorMessage: name.length === 0 ? validatorMessages.name : null,
    });
  }

  private onPhoneValueChanged(phone: string) {

    if (!this.state.validated) {
      this.setState({ phone });
      return;
    }

    this.setState({
      phone,
      phoneValidatorMessage: phone.length === 0 ? validatorMessages.phone : null,
    });
  }

  private sendRequest() {
    this.setState({ validated: true });

    if (!this.validateRequiredFields()) {
      return;
    }

    const isProd = environment === 'production';
    const url = `${isProd ? 'https://www.cian.ru' : ''}/ajax/feedback/`;

    superagent
      .post(url)
      .send(this.prepareMessage())
      .set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8')
      .end((err, res) => {
        if (err) {
          showNotification('error', 'Не удалось отправить заявку, попробуйте еще раз.');
          return;
        }

        showNotification('success', 'Ваша заявка успешно отправлена');
      });

    this.props.onRequestSend();
  }

  private validateRequiredFields(): boolean {
    const { name, phone } = this.state;

    let isValid = true;

    let nameValidatorMessage = name.length ?  null : validatorMessages.name;
    let phoneValidatorMessage = phone.length ? null : validatorMessages.phone;

    if (nameValidatorMessage || phoneValidatorMessage) {
      isValid = false;
    }

    this.setState({
      nameValidatorMessage,
      phoneValidatorMessage,
    });

    return isValid;
  }

  private onKeyPressed(keyCode: number) {
    //escape key maps to keycode `27`
    if (keyCode === 27) {
      this.props.onRequestSend();
    }
  }

  private onLayoutClick() {
    this.props.onRequestSend();
  }

  private prepareMessage() {
    let message = `
        Тип заявки
        ${this.state.type}
        Имя и фамилия
        ${this.state.name}
        Телефон
        ${this.state.phone}
        Email
        ${this.state.email}
        Назание БЦ
        ${this.state.bscTitle}
        Комментарий
        ${this.state.comment}
    `;

    return {
      source: 'bsc_request',
      text: message,
    };
  }
}



// WEBPACK FOOTER //
// ./src/bundles/business_shopping_centers_serp/components/bsc_add_request/bsc_add_request_dialog.tsx